import { render, staticRenderFns } from "./LeituraRegulamento.vue?vue&type=template&id=fb3ae59e&scoped=true&"
import script from "./LeituraRegulamento.vue?vue&type=script&lang=js&"
export * from "./LeituraRegulamento.vue?vue&type=script&lang=js&"
import style0 from "./LeituraRegulamento.vue?vue&type=style&index=0&id=fb3ae59e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3ae59e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
